import React from "react";

// Legacy Google One Tap widget that auto-submitted to the passport
// /auth/google endpoint. Disabled under Identity Platform — sign-in now goes
// through firebaseAuth.signInWithGoogle (see Header). Kept as a no-op so the
// existing <Autolog /> placement in App doesn't need to change; One Tap can be
// re-introduced later via Identity Platform if desired.
const Autolog = () => null;

export default Autolog;
